/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import {
  style,
  animate,
  keyframes,
} from '@angular/animations';

export const BulbAnimations: any = {};

BulbAnimations.increment_number = animate('500ms', keyframes([
  style({ visibility: 'visible', opacity: 0 }),
  style({ transform: 'translateY(0.3em)', opacity: 1 }),
  style({ transform: 'translateY(-0.5em)', opacity: 1 }),
  style({ transform: 'translateY(0)' }),
]));

BulbAnimations.decrement_number = animate('300ms', keyframes([
  style({ visibility: 'visible', opacity: 0 }),
  style({ transform: 'translateY(0.5em)', opacity: 1 }),
  style({ transform: 'translateY(0)' }),
]));

BulbAnimations.circle_outline = animate('200ms 250ms cubic-bezier(0.17, 0.67, 0.88, 0.1)', keyframes([
  style({ border: '1px #96223B solid', offset: 0 }),
  style({ transform: 'scale(1.0)', offset: 0.4 }),
  style({ transform: 'scale(1.0)', offset: 0.8 }),
  style({ border: 'none', offset: 1 }),
]));

BulbAnimations.circle_starburst = animate('300ms', keyframes([
  style({
    background: 'radial-gradient(50% 50% at 50% 50%, rgba(245, 152, 157, 0.8) 0%, rgba(245, 152, 157, 0) 100%)',
    offset: 0,
  }),
  style({ transform: 'scale(0.2)', offset: 0.2 }),
  style({ transform: 'scale(0.4)', offset: 0.3 }),
  style({ transform: 'scale(0.6)', offset: 0.4 }),
  style({ transform: 'scale(1.0)', offset: 0.8 }),
  style({ background: 'none', offset: 1 }),
]));

BulbAnimations.heart_fill = animate('500ms', keyframes([
  style({ opacity: 0, offset: 0 }),
  style({ opacity: 0.5, offset: 0.5 }),
  style({ opacity: 1, offset: 1 }),
]));

BulbAnimations.heart_empty = animate('500ms', keyframes([
  style({ fill: '#96223B', opacity: 0, offset: 0 }),
  style({ fill: '#363d47', opacity: 0.5, offset: 0.5 }),
  style({ fill: '#363d47', opacity: 1, offset: 1 }),
]));
